import React, { useState } from "react";

//UI Material
import {
  Button,
  Card,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

//Material Icons
import { Add } from "@mui/icons-material";

//Local components
import OrderRow from "../orders-list-page/OrderRow";

//Helpers
import { searchEngine } from "../../Helpers/searchEngine";

export default function OrdersTable({ data, getOrders }) {
  // ==========>Component States<==========
  //State for select page
  const [page, setPage] = useState(0);
  //State for manage rows per page
  const [rowsPerPage, setRowsPerPage] = useState(100);
  //State for query in orders
  const [searchQuery, setSearchQuery] = useState("");
  //User data from localStorage
  const userData = JSON.parse(localStorage.getItem("userData"));

  // ==========> Component Functions <==========
  //Function to manage page selection
  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  //Function to control rows per page options
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //Function for data query
  const filterData = (query, data) => {
    if (!query) {
      return data;
    } else {
      return searchEngine(data, query);
    }
  };

  //Data in the table
  const dataFiltered = filterData(searchQuery, data);

  // ==========> Component <==========
  return (
    <Grid container spacing={1} justifyContent="center">
      <Grid item xs={12}>
        <Card raised>
          <Grid container spacing={1}>
            <Grid item xs={12} sx={{ marginTop: 2 }}>
              <Typography variant="h7" fontWeight="bold">
                Registro de órdenes
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Stack
                direction="row"
                spacing={1}
                sx={{ p: 2 }}
                alignItems="center"
                justifyContent="space-between"
              >
                <TextField
                  id="search-bar"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                  fullWidth
                  label="Buscar"
                  variant="outlined"
                  placeholder="Buscar..."
                  size="small"
                />
                <Button
                  disabled={!userData.role === "ADMINISTRATOR"}
                  startIcon={<Add />}
                  size="small"
                  sx={{ color: "white" }}
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    window.location.href = "/new-order";
                  }}
                >
                  Crear 
                </Button>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <TableContainer>
                <Table aria-label="orders-table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          No. Orden
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Nombre del cliente
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Cantidad
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Producto
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Estado
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Fecha de creación
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Fecha de entrega
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Ver más
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {dataFiltered.length > 0 ? (
                      <OrderRow
                        getOrders={getOrders}
                        orders={dataFiltered
                          .sort(
                            (a, b) => new Date(b.dueDate) - new Date(a.dueDate)
                          )
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )}
                      />
                    ) : (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          <Typography variant="body2">
                            No hay órdenes registradas.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={dataFiltered.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                labelRowsPerPage="Filas"
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
